import InfoTooltip from "components/info-tooltip"

export default function setListeners() {
  const els = Array.from(document.querySelectorAll(".js-info-tooltip"))
  els.forEach((el) => {
    const { title, textContent } = JSON.parse(el.dataset.infoTooltip)
    const tooltip = new InfoTooltip(title, textContent)

    el.addEventListener("mouseenter", () => {
      tooltip.append(() => tooltip.moveTo(el, () => {}))
    })

    el.addEventListener("mouseleave", () => {
      tooltip.remove(() => {})
    })
  })
}
